// Reading.tsx

import React from 'react';
import './Reading.css';

const books = [
  { title: 'The Compound Effect', author: 'Darren Hardy' },
  { title: 'The Magic', author: 'Rhonda Byrne' },
  { title: 'Do It Today', author: 'Darius Foroux' },
  { title: 'Zero to One', author: 'Peter Thiel' },
  { title: 'Atomic Habits', author: 'James Clear' },
  { title: 'Deep Work', author: 'Cal Newport' },
  { title: 'The Psychology of Money', author: 'Morgan Housel' },
  { title: 'The Power of Your Subconscious Mind', author: 'Joseph Murphy' },
  { title: 'Verity', author: 'Colleen Hoover' },
];

const Reading: React.FC = () => {
  return (
    <div className="reading-container">
      <h2 className="reading-title">📚 Books That Shaped My Journey</h2>
      <p className="reading-intro">These books have influenced my perspectives, motivation, and self-growth.</p>
      <div className="books-list">
        {books.map((book, index) => (
          <div key={index} className="book-item">
            {book.title} by {book.author}
          </div>
        ))}
        <div className="book-item">and more</div>
      </div>
    </div>
  );
};

export default Reading;
